import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MetaService } from '../../services/meta.service';
import { URLDialog } from '../dialogs/urldialog/url.dialog';

export interface App {
    id: string;
    name: string;
    url: string;
    description: string;
}

@Component({
    selector: 'app-monitoring',
    templateUrl: './app-monitoring.page.html',
    styleUrls: ['./app-monitoring.page.css']
})
export class AppMonitoringPage implements OnInit {
    apps: App[];
    cols: any[];
    searchTerm: string = '';

    constructor(private router: Router, private service: MetaService) {
        this.apps = [];
    }

    ngOnInit() {
        this.cols = [
            { field: 'name', header: 'App' },
            { field: 'description', header: '@@Beschreibung' },
            { field: 'url', header: 'URL' }
        ];
        this.service.LoadNavigationStructures().subscribe(x => {
            if (x) {
                const url = location.origin + '/';
                const data: App[] = [];
                x.forEach((app: any) => {
                    data.push({
                        id: app.SID,
                        name: app.Caption,
                        url: url + app.Caption,
                        description: app.Description
                    });
                });
                this.apps = [...data];
            }
        });
    }

    createWithBackend(): void {
        this.router.navigate(['/settings/layout/navigation/navi-overview']);
    }

    goToApp(app: App): void {
        window.open(app.url, '_blank');
    }

    showPreview(app: App) {
        URLDialog.ShowDialog(app.url, app.name);
    }
}
